import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IsPeriodNavigatorService {

  // Parameters coming from the form selection
  private selectedDate: Date;
  private selectedFrequency: string;
  private selectedAggregation: string;

  // [ "from", "to" ] value that will be used to set queryparameters. Initialized to current day
  public parsedDate = new Subject<[string, string]>();

  constructor(
    private _translateService: TranslateService,
    private _route: ActivatedRoute
  ) { }

  ngOnInit(): void {
  }

  public getFrequency(): string {
    return this.selectedFrequency;
  }

  public getAggregation(): string {
    return this.selectedAggregation;
  }

  public setFrequency(frequency): void {
    this.selectedFrequency = frequency;
  }

  public setDate(date: Date, frequency: string, aggregation?: string): void {
    // Setting the form parameters
    this.selectedDate = date;
    this.selectedFrequency = frequency;
    if (aggregation) {
      this.selectedAggregation = aggregation;
    }

    this.setParsedDate();
  }

  private setParsedDate(): void {
    // Temporary variable that will store the "next" value of the observable
    const tempDate: [string, string] = ['', ''];

    // Parses "from" and "to" depending on the selected frequency
    if (this.selectedFrequency === 'daily') {
      tempDate[0] = moment(this.selectedDate).utcOffset(0, true).format();
      console.log(tempDate[0]);
      tempDate[1] = moment(this.selectedDate).add(1, 'days').utcOffset(0, true).format();
    } else if (this.selectedFrequency === 'weekly') {
      const dayOfMonth = this.selectedDate.getDate();
      const dayOfWeek = this.selectedDate.getDay();
      const firstDayOfWeekNum = dayOfMonth - dayOfWeek + (dayOfWeek == 0 ? -6 : +1);
      const firstDayOfWeek = new Date(this.selectedDate.setDate(firstDayOfWeekNum));

      tempDate[0] = moment(firstDayOfWeek).utcOffset(0, true).format();
      tempDate[1] = moment(firstDayOfWeek).add(1, 'week').utcOffset(0, true).format();
    } else if (this.selectedFrequency === 'monthly') {
      const selectedMonth = this.selectedDate.getMonth();
      const selectedYear = this.selectedDate.getFullYear();

      const firstDay = new Date(selectedYear, selectedMonth, 1);
      const lastDay = new Date(selectedYear, selectedMonth + 1, 0);

      tempDate[0] = moment(firstDay).utcOffset(0, true).format();
      tempDate[1] = moment(lastDay).add(1, 'days').utcOffset(0, true).format();

    } else if (this.selectedFrequency === 'yearly') {
      const selectedYear = this.selectedDate.getFullYear();

      const firstDay = new Date(selectedYear, 0);
      const lastDay = new Date(selectedYear + 1, -1, 31);

      tempDate[0] = moment(firstDay).utcOffset(0, true).format();
      tempDate[1] = moment(lastDay).add(1, 'days').utcOffset(0, true).format();

    } else if (this.selectedFrequency === 'personalized') {
      tempDate[0] = moment(this.selectedDate).utcOffset(0, true).format();
      tempDate[1] = moment(this.selectedDate).add(1, 'days').utcOffset(0, true).format();
    }
    console.log(tempDate);
    // Updates the observable
    this.parsedDate.next(tempDate);
  }

  public getParsedDate() {
    return this.parsedDate;
  }

  public setRangeParsedDate(range): void {
    // Temporary variable that will store the "next" value of the observable
    const tempDate: [string, string] = ['', ''];
    tempDate[0] = moment(range.start).utcOffset(0, true).format();
    tempDate[1] = moment(range.end).add(1, 'days').utcOffset(0, true).format();
    this.parsedDate.next(tempDate);
  }
}
